var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c('activix-accordion-item',{key:index,staticClass:"mb-3",attrs:{"item":item,"index":index}},[_c('template',{slot:"header"},[_vm._t("header",null,{"item":item})],2),_vm._t("default",null,{"item":item})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }